import React, { useRef, useEffect, useState } from "react"
import Property from "./card/Property"
import { gsap, Linear } from "gsap"
import { Draggable } from "gsap/Draggable"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"

export default function Featured({ data }) {
  const sliderRef = useRef(null)
  const slideRef = useRef(null)
  const [action, setAction] = useState(0)
  useEffect(() => {
    const slideWidth = sliderRef.current.firstChild.offsetWidth
    const boxes = sliderRef.current.childElementCount
    const wrapWidth = slideWidth * boxes
    gsap.registerPlugin(Draggable)
    Draggable.create(sliderRef.current, {
      type: "x",
      bounds: {
        minX: -sliderRef.current.clientWidth + window.innerWidth * 0.59,
        maxX: 0,
      },
      throwProps: true,
      snap: {
        x: gsap.utils.snap(wrapWidth),
      },
      inertia: true,
    })
  }, [sliderRef, slideRef])

  useEffect(() => {
    const slot = gsap.utils.toArray(".property")
    if (slot.length - 1 < action) {
      setAction(0)
    } else if (action - 1 < 0) {
      setAction(0)
    }

    gsap.set(slot, {
      duration: 0.3,
      x: -slot[0].offsetWidth * action,
      ease: Linear.easeOut,
    })
    // console.log(slot.length, slot[0].offsetWidth, action)
  }, [action])

  return (
    <section className=" py-12 md:py-20">
      <div className="max-w-6xl w-11/12 lg:w-full mx-auto">
        <div className="text-center">
          <h2 className="text-xl md:text-3xl font-bold">Featured Properties</h2>
          <p className="max-w-2xl mx-auto text-sm text-gray-400 py-4">
            Whether you are planning on moving to Ibiza or on buying a holiday
            home, we at TOG Properties make the crucial difference that will put
            your unique needs in the center of the proceedings.
          </p>
        </div>
      </div>
      <div className="flex space-x-2 items-stretch relative max-w-6xl mx-auto overflow-hidden h-[556px]">
        <div className="hidden w-1/6 md:flex justify-center self-center">
          <button
            disabled={action <= 0 ? true : false}
            onClick={() => setAction(action => action - 1)}
            className={`text-white px-8 py-3 rounded ${
              action <= 0 ? " cursor-not-allowed bg-stone-800" : "bg-black"
            }`}
          >
            <FaArrowLeft />
          </button>
        </div>
        <div
          id="slides"
          className="w-11/12 md:w-4/6 overflow-hidden relative after:absolute after:h-full after:w-6 after:right-0 after:top-0 after:bg-gradient-to-r after:to-gray-100 after:from-transparent before:absolute before:h-full before:w-6 before:z-50 before:left-0 before:top-0 before:bg-gradient-to-l before:to-gray-100 before:from-transparent px-8"
        >
          <div className="absolute" id="wrapper">
            <div
              ref={sliderRef}
              className=" w-full flex justify-center space-x-3"
            >
              {data.map((property, key) => {
                return (
                  <Property
                    slug={`/property/${property.node.slug.current}`}
                    key={key}
                    id="property"
                    reff={slideRef}
                    image={property.node.cover.asset.gatsbyImageData}
                    price={property.node.price}
                    title={property.node.name}
                    type={property.node.type}
                    location={property.node.location}
                    area={property.node.area}
                    bed={property.node.bed}
                    bath={property.node.bath}
                    // sold={property.node.frontmatter.sold}
                    pool={property.node.pool}
                    land={property.node.land}
                    propertyID={property.node.ref}
                  />
                )
              })}
            </div>
          </div>
        </div>
        <div className="hidden w-1/6 md:flex justify-center self-center">
          <button
            onClick={() => setAction(action => action + 1)}
            className="bg-black rounded text-white px-8 py-3"
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  )
}
